export default __webpack_public_path__ + "static/media/left-arrow.a3998e7b.svg";